import React from 'react';

import useModal from '@/hooks/useModal';
import useApi from '@/hooks/useApi';

import { Button } from '@/components/global/Button';

import { TRecommendation } from '@/services/requests/Recommendation/types/template4';
import { getTerms } from '@/services/requests/Liferay';

type TProps = {
  data: TRecommendation;
};

export function Rules({ data }: TProps) {
  const modal = useModal();
  const { ApiLiferay } = useApi();

  async function handlerRules() {
    let modalTitle = 'Ops!';
    let modalContent = 'Desculpa! Não conseguimos carregar o conteúdo.';
    try {
      const response = await getTerms(ApiLiferay, data.rules.content_key);
      if (response) {
        modalTitle = response.title;
        modalContent = response.content;
      }
    } catch (error) {
      console.warn('error', error);
    }
    modal.setContent(modalTitle, modalContent);
    modal.setShow(true);
  }

  return (
    <Button
      className="vitrine-template4__button"
      text={data.rules.label}
      onClick={() => handlerRules()}
    />
  );
}
